import {
  type ElasticFilter,
  EXPORT_ENTITIES,
  EXPORT_ENTITIES_LABEL,
  type ExportFilter,
  type ExportType,
  isEmpty,
  toAdvancedCustomFields,
  type WorkflowId,
} from '@terros/common'
import { mergeCustomFieldFilters } from '../account/util'

export const toReadableExportType = (type: ExportType): string => {
  if (EXPORT_ENTITIES.includes(type)) {
    return EXPORT_ENTITIES_LABEL[type]
  }
  return type
}

const emptyToUndefined = <T>(values: T[] | undefined): T[] | undefined => {
  if (isEmpty(values)) return undefined
  return values
}

export const buildAccountExportFilter = ({
  filters,
  workflowId,
  searchByCurrentStage,
}: {
  filters: ElasticFilter
  workflowId?: WorkflowId
  searchByCurrentStage?: boolean
}): ExportFilter => {
  return {
    workflowId,
    teamIds: emptyToUndefined(filters.teamIds),
    userIds: emptyToUndefined(filters.userIds),
    statusIds: emptyToUndefined(filters.statusIds),
    stageIds: emptyToUndefined(filters.workflowStageIds),
    searchByCurrentStage,
    cities: emptyToUndefined(filters.cities),
    states: emptyToUndefined(filters.states),
    zipCodes: emptyToUndefined(filters.zipCodes),
    advancedCustomFields: mergeCustomFieldFilters(
      toAdvancedCustomFields(filters.customFields),
      filters.advancedCustomFields
    ),
  }
}
